import React from "react";
import { Controller } from "react-hook-form";
import { FormGroup, Input, Checkbox } from "@cofano/cck";
import { Grid, RadioGroup, FormControlLabel, Radio } from "@mui/material";
import { Language } from "imports/Utils";

export default ({ control }) => {
	return (
		<Grid xs={6} item>
			<FormGroup label={Language("LETTER_OF_PROTEST_QUANTITY")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="protestVariables.quantityApplicable"
					control={control}
					render={({ field }) => <Checkbox {...field} checked={field.value} />} />
			</FormGroup>

			<FormGroup label={Language("LETTER_OF_PROTEST_SHIP_FIGURES_APPLICABLE")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="protestVariables.shipFigureDifferenceApplicable"
					control={control}
					render={({ field }) => <Checkbox {...field} checked={field.value} />} />
			</FormGroup>

			<FormGroup label={Language("LETTER_OF_PROTEST_SHIP_FIGURES_MT")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="protestVariables.shipFiguresMt"
					control={control}
					render={({ field }) => <Input {...field} />} />
			</FormGroup>

			<FormGroup label={Language("LETTER_OF_PROTEST_SHIP_FIGURES_PERCENTAGE")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="protestVariables.shipFiguresPercentage"
					control={control}
					render={({ field }) => <Input {...field} />} />
			</FormGroup>

			<FormGroup label={Language("LETTER_OF_PROTEST_BL_FIGURES_APPLICABLE")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="protestVariables.blFigureDifferenceApplicable"
					control={control}
					render={({ field }) => <Checkbox {...field} checked={field.value} />} />
			</FormGroup>

			<FormGroup label={Language("LETTER_OF_PROTEST_BL_FIGURES_MT")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="protestVariables.blFiguresMt"
					control={control}
					render={({ field }) => <Input {...field} />} />
			</FormGroup>

			<FormGroup label={Language("LETTER_OF_PROTEST_BL_FIGURES_PERCENTAGE")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="protestVariables.blFiguresPercentage"
					control={control}
					render={({ field }) => <Input {...field} />} />
			</FormGroup>

			<FormGroup label={Language("GENERAL")} overflow="hidden">
				<div style={{ paddingLeft: 16, paddingTop: 16 }}>
					<div style={{ marginBottom: 8 }}>
						<Controller
							name="protestVariables.generalDifferenceApplicable"
							control={control}
							render={({ field }) => <Checkbox {...field} checked={field.value} label={Language("LETTER_OF_PROTEST_GENERAL_FIGURES_APPLICABLE")} />} />
					</div>

					<div style={{ marginBottom: 8 }}>
						<Controller
							name="protestVariables.generalWeightApplicable"
							control={control}
							render={({ field }) => <Checkbox {...field} checked={field.value} label={Language("LETTER_OF_PROTEST_GENERAL_WEIGHT_APPLICABLE")} />} />
					</div>

					<div style={{ marginBottom: 8 }}>
						<Controller
							name="protestVariables.generalVolumeApplicable"
							control={control}
							render={({ field }) => <Checkbox {...field} checked={field.value} label={Language("LETTER_OF_PROTEST_GENERAL_VOLUME_APPLICABLE")} />} />
					</div>

					<div style={{ marginBottom: 8 }}>
						<Controller
							name="protestVariables.generalProvisionalApplicable"
							control={control}
							render={({ field }) => <Checkbox {...field} checked={field.value} label={Language("LETTER_OF_PROTEST_GENERAL_PROVISIONAL_APPLICABLE")} />} />
					</div>

					<div style={{ marginBottom: 8 }}>
						<Controller
							name="protestVariables.generalMeasuredApplicable"
							control={control}
							render={({ field }) => <Checkbox {...field} checked={field.value} label={Language("LETTER_OF_PROTEST_GENERAL_MEASURED_APPLICABLE")} />} />
					</div>

					<div style={{ marginBottom: 8 }}>
						<Controller
							name="protestVariables.generalOutturnWeightApplicable"
							control={control}
							render={({ field }) => <Checkbox {...field} checked={field.value} label={Language("LETTER_OF_PROTEST_GENERAL_OUTTURN_WEIGHT_APPLICABLE")} />} />
					</div>

					<Controller
						name="protestVariables.generalVolume15Applicable"
						control={control}
						render={({ field }) => <Checkbox {...field} checked={field.value} label={Language("LETTER_OF_PROTEST_GENERAL_VOLUME_15_APPLICABLE")} />} />
				</div>
			</FormGroup>

			<FormGroup label={Language("LETTER_OF_PROTEST_GENERAL_FIGURES_MT")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="protestVariables.generalMt"
					control={control}
					render={({ field }) => <Input {...field} />} />
			</FormGroup>

			<FormGroup label={Language("LETTER_OF_PROTEST_GENERAL_FIGURES_PERCENTAGE")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="protestVariables.generalPercentage"
					control={control}
					render={({ field }) => <Input {...field} />} />
			</FormGroup>
		</Grid>
	);
};

